import React from 'react';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { TransitionProps } from '@mui/material/transitions';
import { IFeature } from 'types/feature';
import ImageGallery from 'react-image-gallery';
import './styles.css';

interface IFeatureDialog {
  feature: IFeature | null;
  onClose: () => void;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FeatureDialog: React.FC<IFeatureDialog> = ({ feature, onClose }) => {
  const images =
    feature?.gallery?.map?.((item) => ({
      original: `/images/${item}`,
      thumbnail: `/images/${item}`,
    })) ?? [];

  return (
    <Dialog
      fullScreen
      open={!!feature}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: 'sticky' }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {feature?.title}
          </Typography>
          <IconButton
            autoFocus
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Grid container spacing={2} sx={{ padding: 1 }}>
        <Grid item sm={12} md={6} sx={{ width: '100%' }}>
          <ImageGallery items={images} />
        </Grid>
        <Grid item sm={12} md={6}>
          <Stack direction="column">
            <Typography
              variant="body2"
              color="primary"
              sx={{ whiteSpace: 'pre-wrap', marginBottom: 3 }}
            >
              {feature?.shortDescription}
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ whiteSpace: 'pre-wrap' }}
            >
              {feature?.description}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default FeatureDialog;
